module.exports = __webpack_public_path__ + "static/media/honda-star.be5b4268.svg";